import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from './util';
const Small = (_jsx("svg", Object.assign({ xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 16 16" }, { children: _jsx("path", { fill: "currentColor", d: "M7 12V9h2V0H0v9h2v3h2v.54A3.46 3.46 0 0 0 7.47 16v-1A2.46 2.46 0 0 1 5 12.54V12zM1 8V1h3v3h1V1h3v7H1zm2 1h3v2H3z" }, void 0) }), void 0));
export const variants = {
    small: Small,
    default: Small,
};
export default withVariants(variants);
